import ready, { HTML } from 'Utils';
import fancyappsModal from 'Components/fancyapps-modal';
import floorPlansSlider from 'Components/floor-plans-slider';
import fontSizeSwitcher from 'Components/font-size-switcher';
import hamburgerMenu from 'Components/hamburger-menu';
import headerHoverFix from 'Components/header-hover-fix';
import imageSlider from 'Components/image-slider';
import mainNav from 'Components/mainNav';
import newsSlider from 'Components/news-slider';
import revealCtas from 'Components/reveal-ctas';
import section8Notice from 'Components/section8-notice';
import tabs from 'Components/tabs';

ready(() => {
  HTML.classList.add('is-loaded');
  fancyappsModal();
  floorPlansSlider();
  fontSizeSwitcher();
  hamburgerMenu();
  headerHoverFix();
  imageSlider();
  mainNav();
  newsSlider();
  revealCtas();
  section8Notice();
  tabs();
});
